import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class PurchaseRequestServices {
  /**
   * @param {*} tenantId
   * @param {*} status
   * @param {*} fromDate
   * @param {*} toDate
   * @param {*} deliveryFromDate
   * @param {*} deliveryToDate
   * @param {*} tenantRoleId
   * @param {*} page
   * @param {*} limit
   * @param {*} searchKeyword
   * @param {*} tenantDepartmentId
   * @param {*} moId
   * @param {*} prId
   * @param sourceDepartmentId
   * @return
   */
  downloadPRData = async (payload) => {
    const purchaseRequests = await Helpers.post({
      url: Constants.PURCHASE_REQUESTS_DOWNLOAD_DATA,
      data: payload,
    });
    return purchaseRequests;
  };

  /**
 * @param {*} tenantId
 * @param {*} status
 * @param {*} fromDate
 * @param {*} toDate
 * @param {*} deliveryFromDate
 * @param {*} deliveryToDate
 * @param {*} tenantRoleId
 * @param {*} page
 * @param {*} limit
 * @param {*} searchKeyword
 * @param {*} tenantDepartmentId
 * @param {*} moId
 * @param {*} prId
 * @param sourceDepartmentId
 * @return
 */
  getPurchaseRequests = async (tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen, sourceTenantId, isDropdownList, issuerTenantId, issuerDepartmentId,
  ) => {
    let url = `${Constants.PURCHASE_REQUESTS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (isListScreen) url += `is_list=${isListScreen}&`;
    if (status) url += `status=${status}&`;
    if (fulfillmentStatus) url += `fulfillment_status=${fulfillmentStatus}&`;
    if (fromDate) url += `from_date=${fromDate}&`;
    if (toDate) url += `to_date=${toDate}&`;
    if (deliveryFromDate) url += `delivery_from_date=${deliveryFromDate}&`;
    if (deliveryToDate) url += `delivery_to_date=${deliveryToDate}&`;
    if (tenantRoleId) url += `tenant_role_id=${tenantRoleId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (sourceDepartmentId) url += `source_tenant_department_id=${sourceDepartmentId}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (departmentId) url += `department_ids=${[departmentId]}&`;
    if (moId) url += `mo_id=${moId}&`;
    if (productSearch) url += `product_sku_ids=${productSearch}&`;
    if (prId) url += `purchase_requisition_id=${prId}&`;
    if (label) url += `tags=${label}&`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    if (sourceTenantId) url += `source_tenant_id=${sourceTenantId}&`;
    if (isDropdownList) url += `is_dropdown_list=${isDropdownList}&`;
    if (issuerTenantId) url += `issuer_tenant_id=${issuerTenantId}&`;
    if (issuerDepartmentId) url += `issuer_department_id=${issuerDepartmentId}&`;

    const purchaseRequests = await Helpers.get({ url });
    return purchaseRequests;
  };

  /**
   * @param prId
   * @param tenantId
   * @return {Promise<*>}
   */
  getPurchaseRequestById = async (prId, tenantId) => {
    let url = `${Constants.PURCHASE_REQUESTS}?`;
    if (prId) url += `purchase_requisition_id=${prId}&`;
    if (tenantId) url += `tenant_id=${tenantId}`;
    const purchaseRequest = await Helpers.get({ url });
    return purchaseRequest;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createPurchaseRequest = async (payload) => {
    const purchaseRequest = await Helpers.post({
      url: Constants.PURCHASE_REQUESTS,
      data: payload,
    });
    return purchaseRequest;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePurchaseRequest = async (payload) => {
    const purchaseRequest = await Helpers.put({
      url: Constants.PURCHASE_REQUESTS,
      data: payload,
    });
    return purchaseRequest;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePrStatus = async (payload) => {
    const updatedPr = await Helpers.post({
      url: `${Constants.PURCHASE_REQUESTS}/status`,
      data: payload,
    });
    return updatedPr;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  deletePurchaseRequest = async (payload) => {
    const deletePurchaseRequest = await Helpers.delete({
      url: Constants.PURCHASE_REQUESTS,
      data: payload,
    });
    return deletePurchaseRequest;
  };

  /**
   *
   * @param tenantId
   * @return {Promise<*>}
   */
  getPrSequence = async (tenantId) => {
    const prSequence = await Helpers.get({
      url: `${Constants.GET_PO_SEQUENCE}?tenant_id=${tenantId}`,
    });
    return prSequence;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updatePrWorkflowStep = async (payload) => {
    const workflowStep = await Helpers.post({
      url: `${Constants.PURCHASE_REQUESTS}/workflow`,
      data: payload,
    });
    return workflowStep;
  };

  getPrAvailability = async (prIds, tenantId, tenantDepartmentId, prLineIds, mrpId) => {
    let url = `${Constants.PURCHASE_REQUESTS}/get_pr_available_qty?`;
    if (prIds) url += `pr_ids=${prIds}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (tenantId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (prLineIds) url += `pr_line_ids=${prLineIds}&`;
    if (mrpId) url += `mrp_id=${mrpId}&`;
    const pr = await Helpers.get({
      url,
    });
    return pr;
  };

  convertPrToMo = async (payload) => {
    const url = `${Constants.PURCHASE_REQUESTS}/generate_mo?`;
    const so = await Helpers.post({
      url,
      data: payload,
    });
    return so;
  };
}
export default new PurchaseRequestServices();
